import { render, staticRenderFns } from "./TopProductsTable.vue?vue&type=template&id=5d968bb7"
import script from "./TopProductsTable.vue?vue&type=script&lang=js"
export * from "./TopProductsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports